import { render, staticRenderFns } from "./busDetail.vue?vue&type=template&id=ed6c95a0&scoped=true&"
import script from "./busDetail.vue?vue&type=script&lang=js&"
export * from "./busDetail.vue?vue&type=script&lang=js&"
import style0 from "./busDetail.vue?vue&type=style&index=0&id=ed6c95a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed6c95a0",
  null
  
)

export default component.exports